export default __webpack_public_path__ + "static/17_19-c2ea546cc03383bb56e5e42c4851181c.png";